import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import TakeStockOrderEdit from './TakeStockOrderEdit';
import { Button, Popconfirm, Tooltip } from 'antd';
import moment from 'moment';
import ProductEdit from './ProductEdit';
import { useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification'
import DownloadExcel from '../../report/DownloadExcel';

export default function OpeningInventory(props: any) {
    const ref = useRef<any>(undefined);
    let wmService: any = systemConfig.wmService;
    const apiId = "takeStockOrder"
    /**打开商品窗口 */
    const [modalProductOpen, setModalProductOpen] = useState<boolean>(false);

    /**传递商品窗口的数据 */
    const [productData, setProductData] = useState<any>()
    //表头
    const columnsHead = [

        {
            title: "日期",
            dataIndex: "sysDate",
            render: (val: any, record: any) =>
                <span>
                    {moment(val.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                </span>,

        },
           {
            title: "名称",
            dataIndex: "takeStockOrderName",
        },

        {
            title: "部门",
            dataIndex: "deptName",
        },
        {
            title: "审核",
            dataIndex: "deptName",
            render: (val: any, record: any) => {
                let takeStockState = record.takeStockState;

                switch (takeStockState) {
                    case 1:
                        return <></>;
                    case 2:
                        return <Popconfirm title="确定要通过吗？" onConfirm={() => review(record.id)} okText="确定" cancelText="取消">
                            <Button type='text' size='small' danger>通过</Button>
                        </Popconfirm>;
                    case 3:
                        return <>已审核</>
                    default:
                        return <></>

                }



            }

        },
          {
            title: '下载',
            dataIndex: 'contactPhone',
            render: (text: any, record: any) => {
                
              return  <Button disabled={record.takeStockState===3?false:true} onClick={() => DownloadExcel(record, "takeStockOrder", )}>下载EXCEL文件</Button>
            }


        },

    ];

    const review = (id: string) => {
        fetchApi.POST(wmService, {
            apiId: "takeStockOrder",
            apiExtend: "review",
            apiData: {
                id,

            }
        }).then((res) => {
            if (res.success) {
                const currentData: initDataType = {
                    apiId,

                }
                ref.current.initData(currentData);
                antMessage('success', "成功")

            }

        }).catch((err) => {
            antMessage("error", "失败", err)
        })

    }
    const columns = columnsheadId
        .concat(columnsHead as []);

    /** 子表头内容 */
    const expandableColumnsHead: Array<any> = [
        {
            title: "id",
            dataIndex: "id",
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? text.substring(0, 10) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: "商品名称",
            dataIndex: "product",
            render: (text: any) => (text ? text.productName : "")
        },
        {
            title: "商品单位",
            dataIndex: "product",
            render: (text: any) => (text ? text.productUnit.productUnitName : "")
        },
        {
            title: "规格",
            dataIndex: "productSpecifications"
        },
        {
            title: "数量",
            dataIndex: "bNum"
        },
        {
            title: "单价",
            dataIndex: "univalence"
        },
        {
            title: "总价格",
            dataIndex: "totalPrice"
        },
        {
            title: "备注",
            dataIndex: "memo"
        },

    ]

    /**关闭商品窗口并刷新数据 */
    const onCloseProductOpen = (status: Boolean) => {
        setModalProductOpen(false)
        if (status === true) {
            ref.current.initData();
        }
    }
    /** 子表头 */
    const expandableColumns = expandableColumnsHead;
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '盘点单',
        apiId,
        showStates: true,
        columns,
        pagination: true,
        EditComponent: TakeStockOrderEdit,
        mountDataOptions: {
            userMount: {
                isEmployees: true,
                isDept: true,
                isUserAreas: true
            }
        },
        //子表格
        isExpandable: true,
        expandableColumns,
        expandableDataName: 'takeStockProducts',
    };
    return (
        <>
            <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>

            {modalProductOpen ? (<ProductEdit data={productData} closeModal={onCloseProductOpen}
            />)
                : null}
        </>

    )
}
